import { CheckSquareFilled } from "@ant-design/icons";

import { BasicModal } from "@/ui-components/commonComponents/Modal/BasicModal";
import { Button } from "@/ui-components/commonComponents/Button/Button";

import style from "./TemplateCreatedModal.module.css";

interface TemplateCreatedModalProps {
  templateName: string | null;
  clientName: string | null;
  versionNumber: number | null;
  onClose: () => void;
}

export function TemplateCreatedModal({ templateName, clientName, versionNumber, onClose }: TemplateCreatedModalProps) {
  const isNewVersion = typeof versionNumber === "number" && versionNumber > 1;
  const title = isNewVersion
    ? "Assessment Template Version Created Successfully"
    : "Assessment Template Created Successfully";
  const resolvedClientName = clientName ?? "All Clients";

  return (
    <BasicModal
      isModalOpen={!!templateName}
      handleCancel={onClose}
      autoHeight={true}
      footer={[
        <Button key="done" onClick={onClose}>
          Done
        </Button>,
      ]}
    >
      <div className={style.templateCreatedContainer}>
        <h2 className={style.templateCreatedTitle}>{title}</h2>
        {templateName && (
          <p className={style.templateCreatedLine}>
            <CheckSquareFilled className={style.templateCreatedCheckIcon} />
            <span>
              {isNewVersion ? (
                <>
                  <strong>
                    {templateName} - Version {versionNumber}
                  </strong>{" "}
                  Created for <strong>{resolvedClientName}</strong>
                </>
              ) : (
                <>
                  <strong>{templateName}</strong> template created for <strong>{resolvedClientName}</strong>
                </>
              )}
            </span>
          </p>
        )}
      </div>
    </BasicModal>
  );
}
